import { map } from 'lodash';
import { setPharmacies } from './actions';
import PharmaciesService from './PharmaciesService';
import { currentPatientIdSelector } from '../patient';
import { toAddressRequest } from '../util';

// HELPERS
const toPharmacyRequest = (
  {
    addressId,
    addressState,
    city,
    email,
    fax,
    firstName,
    id,
    lastName,
    notes,
    pharmacistId,
    pharmacyName,
    phoneExtension,
    primaryPhoneNumber,
    secondaryStreetAddress,
    streetAddress,
    zipCode,
  },
  patientId,
) => ({
  ...toAddressRequest({
    addressId,
    addressState,
    city,
    secondaryStreetAddress,
    streetAddress,
    zipCode,
  }),
  email,
  extension: phoneExtension,
  fax,
  id,
  name: pharmacyName,
  patientId,
  notes,
  pharmacist: {
    firstName,
    lastName,
    id: pharmacistId,
  },
  pharmacistId,
  phone: primaryPhoneNumber,
});

const toRequest = (pharmacies, patientId) => ({
  pharmacies: map(pharmacies, pharmacy =>
    toPharmacyRequest(pharmacy, patientId),
  ),
  patientId,
});

// THUNKS
export const fetchPharmaciesAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(PharmaciesService.getByPatientId(patientId)).then(
    pharmacies => dispatch(setPharmacies(pharmacies)),
  );
};

export const savePharmaciesAsync = pharmacies => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    PharmaciesService.create(toRequest(pharmacies, patientId)),
  ).then(() => dispatch(setPharmacies(pharmacies)));
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/pharmacies/thunks.js